import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Currency from "../../../components/Currency";
import ImageLoader from "../../../components/ImageLoader";

const useStyles = makeStyles(theme => ({
  product: {
    width: "20%",
    margin: "1% 2.5%",
    position: "relative",
    background: theme.palette.background.paper,
    borderRadius: "5px",
    transition: "all 0.25s",
    overflow: "hidden",
    cursor: "pointer",

    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: `0 0 0 1px ${theme.palette.primary.main},
      0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12)`
    }
  },
  sale: {
    padding: theme.spacing(1),
    display: "inline-block",
    position: "absolute",
    top: "0",
    left: "0",
    fontSize: "1rem",
    color: theme.palette.common.white,
    background: theme.palette.secondary.main,
    borderTopLeftRadius: "5px",
    zIndex: 2
  },
  media: {
    borderBottom: "1px solid",
    borderBottomColor: theme.palette.divider,

    "& img": {
      width: "100%",
      borderTopLeftRadius: "5px",
      borderTopRightRadius: "5px"
    }
  },
  content: {
    padding: theme.spacing(1, 2)
  },
  name: {
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1rem"
  },
  price: {
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  total: {
    fontWeight: 500,
    fontSize: "1.3rem",
    color: theme.palette.primary.main
  },
  full: {
    marginLeft: theme.spacing(2),
    textDecoration: "line-through",
    fontSize: "1.05rem",
    color: theme.palette.text.secondary,

    "&:before": {
      content: '"\\00a0"',
      color: "transparent"
    },
    "&:after": {
      content: '"\\00a0"',
      color: "transparent"
    }
  },
  featured: {
    height: "25px",

    "&:after": {
      content: '"Destacado"',
      padding: theme.spacing(0.5),
      fontSize: "0.8rem",
      color: theme.palette.primary.main,
      border: "1px solid",
      borderColor: theme.palette.primary.main,
      borderRadius: "3px"
    }
  }
}));

const ProductCard = ({ product, onSelected, className = "" }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.product, className)} onClick={() => onSelected(product)}>
      {product.body.sale && product.body.sale.percentage && (
        <div className={classes.sale}>{product.body.sale.percentage}%</div>
      )}
      <div className={classes.media}>
        <ImageLoader
          imgKey={product.medias[0] && product.medias[0].key}
          circularProgressSize={30}
        />
      </div>
      <div className={classes.content}>
        <h3 className={classes.name}>{product.name}</h3>
        <div className={classes.price}>
          {product.body.sale && product.body.sale.percentage ? (
            <>
              <div className={classes.total}>
                <Currency value={product.body.sale.value} />
              </div>
              <div className={classes.full}>
                <Currency value={product.price} />
              </div>
            </>
          ) : (
            <div className={classes.total}>
              <Currency value={product.price} />
            </div>
          )}
        </div>
        {product.body.featured && <div className={classes.featured}></div>}
      </div>
    </div>
  );
};

export default ProductCard;
